import { render } from "./Busy.vue?vue&type=template&id=d299a652"
import script from "./Busy.vue?vue&type=script&lang=js"
export * from "./Busy.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Link\\Documents\\MCOM\\mcom-agri-origin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__